import React from "react";

// reactstrap components
import { Row, Col } from "reactstrap";

// core components

function ServicesHeader() {
  return (
    <>
      <div className="page-header page-header-small">
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" + require("assets/img/bg37.jpg").default + ")",
          }}
        ></div>
        <div className="content-center">
          <Row>
            <Col className="ml-auto mr-auto" md="8">
              <h1 className="title">What We Do</h1>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default ServicesHeader;
